
















































































// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import  { MswApiService } from '@/shared/msw-api-service';
import { SelectedUserGroupObjectType, AllUsersListType, UserListDetail, AddUserToUserGroupBodyType } from '../components/userGroupTypes';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';

const cssPrefix = 'add-user';
@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwCheckbox,
    SwScrollView,
  },
})
export default class AddUser  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  availableUserList:UserListDetail[] = [];
  assignedUSerList: UserListDetail[] = [];
  searchUserString: string = '';
  selectedUserList: string[] = [];
  disableAddButton: boolean = true;
  filteredData: UserListDetail[] = [];

  @Prop()
  userGroupSelected: SelectedUserGroupObjectType;

  onSelectUsers() {
    if (this.selectedUserList.length > 0) {
      this.disableAddButton = false;
    } else {
      this.disableAddButton = true;
    }
  }

  inviteUser() {
    this.$emit('inviteNewUser');
  }

  closeSearchUsers() {
    const searchStr = this.searchUserString.toString()
    .toLocaleLowerCase();
    const searchData: UserListDetail[] = this.availableUserList;
    if (searchStr !== '') {
      this.filteredData = searchData.filter((row: any) => {
        let flag = false;
        for (const key in row) {
          if (Object.prototype.hasOwnProperty.call(row, key)) {
            flag = row[key] ? row[key].toString()
            .toLocaleLowerCase()
            .includes(searchStr) : false;
            if (flag) {
              return flag;
            }
          }
        }
        return false;
      });
    } else {
      this.filteredData = [...this.availableUserList];
    }
  }

  onCancel() {
    this.$emit('cancelAddUserModal');
  }
  addUsers() {
    const addUserBody: AddUserToUserGroupBodyType = {
      bsendMail: null,
      contactLists: [],
    };
    this.availableUserList.map((ele: UserListDetail) => {
      if (this.selectedUserList.includes(ele.emailAddress)) {
        addUserBody.contactLists.push({
          partyGroupId: this.$store.getters['AccessManagementStoreModule/getSelectedUserGroupObject'].partyGroupId || '',
          partyId: ele.partyId,
          action: 'add',
        });
      }
    });
    this.$emit('addUsersToUserGroup', addUserBody);
  }

  formatUserList() {
  }

  getUsersList() {
    const userGroupIdObj = {
      userGroupId: this.userGroupSelected.partyGroupId,
      isfromMasterMSSP: true,
    };
    return new Promise((res, rej) => {
      MswApiService.userGroup.getUserList(userGroupIdObj)
      .then((resp: AllUsersListType) => {
        this.assignedUSerList = resp.content ? resp.content.assignedusers ? resp.content.assignedusers : [] : [];
        this.availableUserList = resp.content ? resp.content.availbleUsers ? resp.content.availbleUsers : [] : [];
        this.filteredData = [...this.availableUserList];
        this.formatUserList();
        res(true);
      })
      .catch(() => {
        rej(true);
      });
    });
  }

  async fetchApiForUsers() {
    try {
      this.$store.commit('startLoading');
      await this.getUsersList();
      this.$store.commit('stopLoading');
    } catch {

    }
  }

  created() {
    this.fetchApiForUsers();
  }
}
